"use strict";
exports.__esModule = true;
var HOST = 'https://auth.avs.io';
var API_VERSION = 2;
exports.DEFAULT_PARAMS = {
    host: HOST,
    authHost: HOST,
    apiVersion: API_VERSION,
    storageProvider: 'cookie'
};
exports.CHECK_AUTH_WINDOW_INTERVAL = 300;
exports.POPUP_OPTIONS = [
    'width=800',
    'height=600',
    'resizable=no',
    'scrollbars=no',
    'status=no',
    'menubar=no',
    'toolbar=no',
    'location=no',
    'directories=no',
].join(',');
exports.YOLO_CONFIG = {
    supportedAuthMethods: ['https://accounts.google.com'],
    supportedIdTokenProviders: [
        {
            uri: 'https://accounts.google.com',
            clientId: '898676391515-g5p7ih2rij9q1r4tscd801h0oe5skqqr.apps.googleusercontent.com'
        },
    ]
};
